//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subline: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: '',
      required: false,
    },
    type: {
      type: String,
      default: 'PageIntro',
    },
    callToActionButton: {
      type: Object,
      default: () => null,
    },
    isHomepage: {
      type: Boolean,
      default: false,
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-learn-03.svg?data`),
          width: 117,
          height: 48,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-connect-03.svg?data`),
          width: 91,
          height: 88,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 165,
          height: 136,
          alt: '',
        },
      ],
    }
  },
}
